import React from "react";
import { ChoiceModel } from "../../models/ChoiceModel";
import { BaseChoice } from "./BaseChoice";
import { QuestionType } from "../../models/enums/QuestionType";
import { getRendererProps } from "../renderers/BaseRenderer";
import RadioRenderer from "../renderers/v2/RadioRenderer";
import ChoiceLabelRenderer from "../renderers/v2/ChoiceLabelRenderer";
import { changeLanguage, respondentSetTimeZone } from "../../redux/actions";

export class Radio extends BaseChoice<{}, {}> {
    onSelect = () => {
        this.updateValue(this.props.choice);
    };

    updateValue(choice: ChoiceModel) {
        if (this.props.isDisabled) return;
        if (this.props.question.type === QuestionType.RespondentLanguage)
            this.props.dispatch(changeLanguage(choice.value));
        if (this.props.question.type === QuestionType.RespondentTimeZone)
            this.props.dispatch(respondentSetTimeZone(choice.value));
        this.setMentions(this.props.variable.name, (mentions) =>
            mentions.set(choice.value, this.props.openEnd),
        );
    }

    renderChoice(choice: ChoiceModel) {
        const { isSelected, isDisabled, variable, gridRendering, choiceRef } = this.props;
        return (
            <>
                <RadioRenderer
                    {...getRendererProps(this.props)}
                    ref={choiceRef}
                    variable={variable}
                    choice={choice}
                    name={variable.name}
                    value={choice.value}
                    onSelect={this.onSelect}
                    checked={isSelected}
                    disabled={isDisabled}
                />
                <ChoiceLabelRenderer
                    {...getRendererProps(this.props)}
                    choice={choice}
                    gridRendering={gridRendering}
                    fontWeight={
                        this.props.question.type === QuestionType.TextHighlighter ? 400 : undefined
                    }
                />
            </>
        );
    }
}
